import React from "react";
import DashboardKpis from "@/components/dashboard/DashboardKpis";
import DashboardCharts from "@/components/dashboard/DashboardCharts";
import ActivitySnapshot from "@/components/dashboard/ActivitySnapshot";
import ForecastMovement from "@/components/dashboard/ForecastMovement";
import RepLeaderboard from "@/components/dashboard/RepLeaderboard";
import RepEfficiency from "@/components/dashboard/RepEfficiency";
import RiskDeals from "@/components/dashboard/RiskDeals";
import { RANGE_OPTIONS } from "@/lib/dateRanges";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Loader2, CalendarRange } from "lucide-react";

export default function Dashboard({ data, theme, range, onRangeChange, rangeLoading }) {
  const k = data.kpis || {};
  const stages = data.pipeline_by_stage || [];
  const aging = data.deal_aging || {};
  const leaderboard = data.leaderboard || [];
  const activity = data.activity_analysis || {};
  const trends = data.trends || [];
  const rangeLabel = RANGE_OPTIONS.find((o) => o.value === range)?.label || "All Time";

  return (
    <div className="space-y-6">
      {/* Global period filter */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div className="flex items-center gap-2">
          <CalendarRange className="w-4 h-4 text-muted-foreground" />
          <Select value={range} onValueChange={onRangeChange}>
            <SelectTrigger className="w-[180px]" data-testid="date-range-select">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {RANGE_OPTIONS.map((o) => (
                <SelectItem key={o.value} value={o.value} data-testid={`range-option-${o.value}`}>
                  {o.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          {rangeLoading && <Loader2 className="w-4 h-4 animate-spin text-muted-foreground" />}
        </div>
        <p className="text-xs text-muted-foreground">
          Closed-deal &amp; activity metrics reflect the selected period · Open pipeline, forecast &amp; risk are as of now
        </p>
      </div>

      <DashboardKpis k={k} />
      <ForecastMovement forecast={data.forecast_by_month} movement={data.pipeline_movement} theme={theme} />
      <ActivitySnapshot activity={activity} rangeLabel={rangeLabel} />
      <DashboardCharts stages={stages} aging={aging} trends={trends} theme={theme} />

      {/* Rep performance */}
      <div className="grid lg:grid-cols-2 gap-6">
        <RepLeaderboard leaderboard={leaderboard} />
        <RepEfficiency efficiency={data.efficiency_by_rep} cycle={data.cycle_by_rep} />
      </div>

      {/* Risk */}
      <RiskDeals aging={aging} overdue={data.overdue_deals} inactive={data.inactive_deals} />
    </div>
  );
}
